import { Card, Container, Grid, Typography, CardContent, Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import React from 'react'



const useStyles = makeStyles((theme) => ({

  SellingContainer: {
    paddingTop: '8rem',
    backgroundColor: "#15244D"
  },
  HeadingContainer: {
    textAlign: "center",


  },
  text: {
    fontFamily: "Zen Dots,cursive",
    color: "#FF5805"
  },
  cardContainer: {
    paddingTop: "3rem"
  },
  Contents: {
    backgroundColor: "#101D6B"
  },
  title: {
    color: "white"
  },
  Price: {
    fontFamily: "Zen Dots,cursive",
    color: "#FF5805"
  },
  firstCardBtn: {
    backgroundColor: "#FF5805",
    "&:hover": {
      backgroundColor: "#FF5805",
    }
  }
}))

export default function Selling() {
  const classes = useStyles();
  return (
    <Grid className={classes.SellingContainer}>
      <Grid>
        <Grid itme className={classes.HeadingContainer}> <Typography variant='h4' className={classes.text}>SELL YOUR BUY CITY</Typography></Grid>

        <Grid item className={classes.cardContainer}>
          <Container maxWidth="lg">
            <Grid container spacing={3}>
              <Grid item xs={12} sm={4}> <Card className={classes.Contents}>
                <CardContent>
                  <Typography className={classes.title} gutterBottom>
                    <i class="fas fa-handshake" style={{ color: "#FF5805" }}></i> Seling Price
                            </Typography>
                  <Typography variant="h6" component="h3" className={classes.Price}>
                    000{" "}USDT
                  </Typography>

                  <br />
                  <Button fullWidth className={classes.firstCardBtn} variant="contained">
                    dd
                  </Button>
                </CardContent></Card></Grid>
              <Grid item xs={12} sm={4}> <Card className={classes.Contents}>
                <CardContent>
                  <Typography className={classes.title} gutterBottom>
                    <i class="fas fa-handshake" style={{ color: "#FF5805" }}></i> Seling Price
                            </Typography>
                  <Typography variant="h6" component="h3" className={classes.Price}>
                    000{" "}USDT
                  </Typography>

                  <br />
                  <Button fullWidth className={classes.firstCardBtn} variant="contained">
                    dd
                  </Button>
                </CardContent></Card></Grid>
              <Grid item xs={12} sm={4}> <Card className={classes.Contents}>
                <CardContent>
                  <Typography className={classes.title} gutterBottom>
                    <i class="fas fa-handshake" style={{ color: "#FF5805" }}></i> Seling Price
                            </Typography>
                  <Typography variant="h6" component="h3" className={classes.Price}>
                    000{" "}USDT
                  </Typography>

                  <br />
                  <Button fullWidth className={classes.firstCardBtn} variant="contained">
                    dd
                  </Button>
                </CardContent></Card></Grid>
            </Grid>

          </Container>
        </Grid>

      </Grid>
    </Grid>
  )
}
